import React from "react";
import { ArrowUp, Star } from "lucide-react";
import { Button } from "./ui/button";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <footer className="bg-gray-900 text-white relative">
      {/* Back to top button */}
      <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
        <Button
          onClick={scrollToTop}
          size="icon"
          className="bg-blue-600 hover:bg-blue-700 shadow-lg hover:shadow-xl transition-all duration-300 rounded-full h-12 w-12"
        >
          <ArrowUp className="h-5 w-5" />
        </Button>
      </div>

      <div className="container mx-auto px-4 lg:px-6 pt-16 pb-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info con Logo GRANDE */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-6 mb-8">
              <img 
                src="/images/nbz5qg9u_logo_star_italia_web.png"
                alt="Star Italia Logo"
                className="h-20 w-auto object-contain"
                style={{ 
                  filter: 'contrast(1.2) saturate(1.2) brightness(1.2)',
                  maxWidth: '200px'
                }}
              />
              <div>
                <h3 className="text-3xl font-bold">Star Italia S.p.a</h3>
                <p className="text-blue-400 font-medium">Il meglio per la tua casa</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              Da oltre 3 generazioni ristrutturiamo case con passione, professionalità e competenza.
              Trasformiamo i tuoi spazi con soluzioni personalizzate e tecnologie all'avanguardia dal 2017.
            </p>
            
            {/* Sedi Aziendali */}
            <div className="space-y-4 text-sm text-gray-400">
              <div>
                <h4 className="text-white font-semibold mb-2">Sede Legale</h4>
                <p>San Damiano 9 - 20121 Milano (MI)</p>
              </div>
              <div>
                <h4 className="text-white font-semibold mb-2">Sede Operativa</h4>
                <p>S.S. Romea 309/63 - 44029 Lido di Spina (FE)</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Link rapidi</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer"
                >
                  Chi Siamo
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer"
                >
                  Servizi
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer"
                >
                  Galleria
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer"
                >
                  Contatti
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Servizi</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('rifacimenti-dettagli')}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer"
                >
                  Rifacimenti Bagni-Docce
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('serramenti-dettagli')}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer"
                >
                  Serramenti Infissi
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('vetrate-dettagli')}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer"
                >
                  Vetrate Panoramiche
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('prestigio-dettagli')}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer"
                >
                  Ristrutturazioni di Prestigio
                </button>
              </li>
            </ul>
            
            {/* Compliance Links COMPLETA */}
            <div className="mt-8">
              <h4 className="text-lg font-semibold mb-4">Compliance</h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="https://drive.google.com/file/d/1wBr-zHCl6iJ6ZweOabt3thil91Wu8b0X/view"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-blue-400 transition-colors duration-200 text-sm flex items-center"
                  >
                    <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                    Codice Etico
                  </a>
                </li>
                <li>
                  <a
                    href="https://drive.google.com/file/d/1rnVixdB6Wc9rF6A5jqS1OHziQLAoCYYF/view"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-blue-400 transition-colors duration-200 text-sm flex items-center"
                  >
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                    Sistema Disciplinare
                  </a>
                </li>
                <li>
                  <a
                    href="http://drive.google.com/file/d/1mnnI9Qklw-HheMTVH_F0Y0tWz-phg1II/view"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-blue-400 transition-colors duration-200 text-sm flex items-center"
                  >
                    <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                    Modello 231
                  </a>
                </li>
                <li>
                  <a
                    href="https://staritaliaspa.segnalazioni.net/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-blue-400 transition-colors duration-200 text-sm flex items-center"
                  >
                    <span className="w-2 h-2 bg-amber-500 rounded-full mr-2"></span>
                    Whistleblowing
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 Star Italia S.p.a. Tutti i diritti riservati.
            </p>
            
            <div className="flex space-x-6 text-sm">
              {/* Privacy Policy con iubenda */}
              <div 
                dangerouslySetInnerHTML={{
                  __html: `<a href="https://www.iubenda.com/privacy-policy/51888746" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe text-gray-400 hover:text-blue-400 transition-colors duration-200" title="Privacy Policy">Privacy Policy</a>`
                }}
              />
              
              <a
                href="/termini-servizio"
                className="text-gray-400 hover:text-blue-400 transition-colors duration-200"
              >
                Termini di Servizio
              </a>
              
              {/* Cookie Policy con iubenda */}
              <div 
                dangerouslySetInnerHTML={{
                  __html: `<a href="https://www.iubenda.com/privacy-policy/51888746/cookie-policy" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe text-gray-400 hover:text-blue-400 transition-colors duration-200" title="Cookie Policy">Cookie Policy</a>`
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;